/* variables that will be used across form components that use this system, mainly for UI purposes **/

export const iconColor = '#3DA9F8';
export const consistentSpacing = 2;
export const iconSize = 35;
